import { DEFAULT_ACTIVE_APP_ID, type AppRegistryEntry } from '../appsRegistry';

export type TenantAppEntry = {
    appId: string;
    isInstalled: boolean;
};

export function getInstalledApps(
    registry: AppRegistryEntry[],
    installedAppIds: string[]
): AppRegistryEntry[] {
    return registry.filter(a => installedAppIds.includes(a.id));
}

export function isAppInstalledIn(installedAppIds: string[], appId: string): boolean {
    return installedAppIds.includes(appId);
}

export function getDefaultAccessibleApp(
    registry: AppRegistryEntry[],
    installedAppIds: string[]
): AppRegistryEntry | undefined {
    const preferred = registry.find(
        a => a.id === DEFAULT_ACTIVE_APP_ID && installedAppIds.includes(a.id)
    );
    return preferred ?? registry.find(a => installedAppIds.includes(a.id));
}
